import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  AuthApiService,
  LoginDTO,
  setAccessToken,
  setRefreshToken,
} from 'features/auth';

const { login } = AuthApiService();

type UseLoginPayload = LoginDTO & {
  persistSession: boolean;
  stationId: number;
};

export const useLogin = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: UseLoginPayload) => {
      const { userName, password } = payload;
      
return login({ userName, password }as any);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);
        message.error(uiMessage);
      },
      onSuccess: (data, variables) => {
        if (data.rs === 1) {
       
          setAccessToken(data.res.token, variables.persistSession);
          setRefreshToken(data.res.refreshToken, variables.persistSession);
        } else {
          message.error(data?.customMessage);
        }
      },
    }
  );
};
